import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { Button, Icon, IconButton, toastStore, Typography } from 'shared/ui'
import { CampaignRoutes } from 'entities/ExportRouters'
import { type IResponseFullCampaign } from 'entities/Campaign'
import { BroadcastApi } from 'entities/Broadcast/api/broadcast'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useBroadcastViewContext } from 'pages/broadcasts/ui/BroadcastView/context/broadcastViewContext'
import { CampaignBanner } from 'pages/broadcasts/ui/BroadcastView/ui/ConvertToCampaign/CampaignBanner/CampaignBanner'
import styles from './styles.module.scss'

export const ConvertToCampaign = observer(() => {
  const { params, broadcastContactsStore } = useBroadcastViewContext()
  const { eventLogStore, organizationStore, userPermissionsStore } = useEntitiesContext()
  const [isShow, setShow] = useState(false)
  const [bannerClosedCount, setBannerClosedCount] = useState(0)

  useEffect(() => {
    BroadcastApi.getBroadcastToCampaignConverting()
      .then((res) => {
        if (!res.data.data?.items.bannerClosedCount || res.data.data?.items.bannerClosedCount < 3) {
          setShow(true)
        }
        setBannerClosedCount(res.data.data?.items.bannerClosedCount || 0)
      })
      .catch(console.error)
  }, [])

  const can_manage_campaigns = userPermissionsStore.getItem('can_manage_campaigns')
  if (!can_manage_campaigns) {
    return null
  }
  if (!isShow) {
    return null
  }

  const onConvertToCampaign = () => {
    eventLogStore.logEvent(
      'Campaign_Used',
      {
        event_id: 'campaign_used',
        action: 'Convert (Broadcast > Campaign)',
        agencyId: organizationStore.agency_id,
      },
      { groupId: organizationStore.id }
    )
    if (broadcastContactsStore.hasHubspotList) {
      toastStore.add({
        type: 'error',
        title: 'HubSpot lists aren’t supported in Campaigns yet',
        desc: 'You’ve selected a HubSpot list to filter broadcast contacts',
      })
    } else {
      const w = window.open(`/${CampaignRoutes.root}/${CampaignRoutes.create}`, '_blank')
      const isRCS = params.send_from?.type === 'from_rcs_sender'

      if (w) {
        const campaign: Partial<IResponseFullCampaign> = {
          name: params.name,
          filters: params.filters.filtersListGroups,
          default_timezone: params.timezone,
          steps: [
            {
              id: null,
              order: 1,
              name: 'Step 1',
              type: isRCS ? 'rcs' : params.is_rvm ? 'ringless' : 'sms',
              payload: {
                message: params.message,
                media_url: params.media_url,
              },
              send_from: params.send_from,
              schedule: params.send_now
                ? {
                    type: 'immediately',
                    options: null,
                  }
                : {
                    type: 'date',
                    options: {
                      date: params.send_at || '',
                      use_contact_timezone: params.is_contact_timezone || false,
                    },
                  },
            },
          ],
        }
        w.sessionStorage.setItem('campaign', JSON.stringify(campaign))
      }
    }
  }

  const handleClose = () => {
    setShow(false)
    setBannerClosedCount(bannerClosedCount + 1)
    BroadcastApi.setBroadcastToCampaignConverting(bannerClosedCount + 1).catch(console.error)
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.left}>
        <div className={styles.title}>
          <Icon icon={'campaigns'} />
          <Typography variant={'body-md-medium'} ariaLabel={'Campaigns'}>
            Campaigns
          </Typography>
        </div>
        <Typography variant={'body-rg-medium'} ariaLabel={'info'}>
          Enroll contacts in a <br />
          sequence of messages
        </Typography>
        <Button
          text={'Convert to campaign'}
          size={'small'}
          contained={'primary'}
          onClick={onConvertToCampaign}
        />
      </div>
      <div className={styles.right}>
        <div className={styles.wrapBanner}>
          <CampaignBanner />
        </div>
      </div>
      <div className={styles.wrapClose}>
        <IconButton
          ariaLabel={'close'}
          icon={'close'}
          variant={'icon'}
          size={'small'}
          color={'tertiary'}
          onClick={handleClose}
        />
      </div>
    </div>
  )
})
